<mat-toolbar class="mc-navbar" color="secondary">
  <router-outlet name="full-navbar-heading"></router-outlet>

  <span class="mc-fill-remaining-flex-space"></span>

  <mc-theme-mode-toggle></mc-theme-mode-toggle>
  <router-outlet name="app-navbar-launch-pad"></router-outlet>
</mat-toolbar>
